// Module
var code = "<div class=\"cr-breadcrumb\" ng-repeat=\"step in $ctrl.steps track by step.value\" ng-class=\"$ctrl.getStepClasses(step)\" ng-click=\"$ctrl.changeStep(step)\" data-global-qa-id=\"{{ step.label }}-tab\"> {{ step.label }} </div> ";
// Exports
export default code;